import { eventChannel } from "redux-saga";

export function preloadImages(urlArray) {
  return eventChannel((emit) => {
    window.SirvHSE.imageStore = window?.SirvHSE?.imageStore ?? {};
    const imageStore = window.SirvHSE.imageStore;

    for (const url of urlArray) {
      let im = new Image();
      im.src = url;
      im.onload = function () {
        imageStore[url] = im;
        emit({ url });
      };
      im.onerror = function (e) {
        console.log("Error in loaderSaga:preloadImages:\n", e);
        emit({ error: e });
      };
    }
    return () => {
      ///SAGA EVENT CHANNEL UNSUBSCRIBE FUNCTION
    };
  });
}
